import Vue from 'vue';
import VueI18n from 'vue-i18n';
import eventBus from './eventBus';
import date from 'date-fns';
import numeral from 'numeral';
import Form from './../utils/form';
import { abilitiesPlugin } from '@casl/vue';
import ability from './ability';
import Vuelidate from 'vuelidate';

export default () => {
  Vue.prototype.$bus = eventBus;
  Vue.prototype.$date = date;
  Vue.prototype.$numeral = numeral;
  // Vue.prototype.$form = form;
  Vue.use(Form);
  Vue.use(abilitiesPlugin, ability.defineAbilities());
  Vue.use(Vuelidate);
  Vue.use(VueI18n);
};
